import { Button, Card, CardContent, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useSearchParams } from 'react-router-dom';
import { PTypography } from '@/components/atoms/Typography/PTypography';
import CenterBox from '@/components/common/CenterBox';
import Logo from '@/components/Logo';

export function SSOErrorDisplay({ logout }: { logout: () => void }) {
  const [countdown, setCountdown] = useState(20);
  const [searchParams] = useSearchParams();

  const errorType = searchParams.get('error_description');
  const isSSOError = errorType === 'USER_NOT_FOUND_SSO';

  useEffect(() => {
    if (countdown <= 0) {
      logout();
      return;
    }

    const timer = setTimeout(() => {
      setCountdown(countdown - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown, logout]);

  useEffect(() => {
    if (!isSSOError) {
      logout();
    }
  }, [isSSOError, logout]);

  if (!isSSOError) {
    return null;
  }

  return (
    <CenterBox sx={{ height: '100vh', bgcolor: 'background.default' }}>
      <Card
        sx={{
          maxWidth: 500,
          width: '100%',
          mx: 2,
          boxShadow: 3,
          borderRadius: 2,
        }}
      >
        <CardContent>
          <Stack spacing={3} alignItems="center" sx={{ py: 2 }}>
            <Logo disabledLink />
            <PTypography variant="h5" align={'center'}>
              SSO login not possible
            </PTypography>
            <PTypography variant="body1" align={'center'} color={'secondary'}>
              Logging in via SSO did not work. There may not be an active Predium account for these credentials.
            </PTypography>
            <Button onClick={() => logout()} variant="contained" fullWidth>
              Log out & back to login ({countdown}s)
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </CenterBox>
  );
}
